module.exports = __webpack_public_path__ + "img/banner1.904d1761.png";